import React, { useEffect, useRef, useState } from "react";
import { BellRing, X } from "lucide-react";
import { api } from "@/lib/api";
import { beepOnce } from "@/lib/ring";

export default function AdminAlerts({ onChange }) {
  const [alerts, setAlerts] = useState([]);
  const seen = useRef(null);

  useEffect(() => {
    const load = () => api.get("/admin/alerts").then((r) => {
      const ids = r.data.map((a) => a.id);
      if (seen.current && r.data.some((a) => a.level === "red" && !seen.current.has(a.id))) beepOnce();
      if (seen.current && ids.some((id) => !seen.current.has(id))) onChange?.();
      seen.current = new Set(ids);
      setAlerts(r.data);
    }).catch(() => {});
    load();
    const iv = setInterval(load, 15000);
    return () => clearInterval(iv);
  }, [onChange]);

  const ack = async (id) => {
    await api.post(`/admin/alerts/${id}/ack`);
    setAlerts((xs) => (id === "all" ? [] : xs.filter((a) => a.id !== id)));
  };
  if (!alerts.length) return null;
  return (
    <div data-testid="admin-alerts" className="mb-6 space-y-2">
      <div className="flex items-center justify-between">
        <div className="font-display font-bold text-[#121316] inline-flex items-center gap-2"><BellRing size={18} className="text-[#C0392B]" /> Alerts</div>
        <button data-testid="admin-alerts-clear" onClick={() => ack("all")} className="text-xs font-bold underline">Clear all</button>
      </div>
      {alerts.map((a) => (
        <div key={a.id} data-testid={`admin-alert-${a.id}`} className={`rounded-2xl px-4 py-3 flex items-start gap-3 font-semibold ${a.level === "red" ? "bg-[#C0392B] text-white" : "bg-[#E8F7EE] text-[#1B8A4B]"}`}>
          <span className="flex-1">{a.message} <span className="text-xs opacity-70">{new Date(a.created_at).toLocaleTimeString()}</span></span>
          <button onClick={() => ack(a.id)} aria-label="Dismiss"><X size={18} /></button>
        </div>
      ))}
    </div>
  );
}
